import React from 'react'
import { Preview } from '../components/Preview'

export const PreviewPage = () => {
    return <Preview />
}
